import React, { PureComponent } from 'react'
import { SearchWrap } from './style'
import Toast from '../../common/toast';
import unit_institution_promotion from '../../../store/asset_institution/unit_institution_promotion'
const imgs = {
    searchIcon: 'https://img11.360buyimg.com/imagetools/jfs/t1/93419/32/32547/3675/633508e2Eeb36fe28/75d56b961e42520a.png',
    clearIcon: 'https://img13.360buyimg.com/imagetools/jfs/t1/30458/33/18594/2967/63350a67E53466c5d/eaea0ac810a25bab.png'
}
class Search extends PureComponent{
    constructor(props) {
        super(props)
        this.state = {
            keyWord: ''
        }
        this.textInput = React.createRef();
    }
    componentDidMount(){
        const {keyWord} = unit_institution_promotion;
        this.setState({keyWord});
    }
    handleSearch = () => {
        // const {keyWord} = this.state;
        const {getPromotionAuctionList,resetAuctionList} = unit_institution_promotion;
        // if(!keyWord.trim()){ 
        //     Toast.fail({
        //         message: '搜索内容不能为空',
        //         duration: 2500
        //       })
        //     return;
        // }else{
        resetAuctionList()
        getPromotionAuctionList()
        // }
    }
    handleInputChange = (e) => {
        const {changeKeyWord} = unit_institution_promotion;
        changeKeyWord(e.target.value);
        this.setState({keyWord: e.target.value});
    }
    handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            this.handleSearch();
            this.textInput.current.blur();
        }
    }
    clearKeyword = () => {
        const {changeKeyWord} = unit_institution_promotion;
        this.setState({keyWord: ''});
        changeKeyWord('');
    }
    render(){
        const {keyWord} = this.state;
        return (
            <SearchWrap>
                <div className='main_search'>
                    <img src={imgs.searchIcon} className='search_icon'/>
                    <input 
                        className='search_input'
                        placeholder='标的物名称'
                        onChange={this.handleInputChange} 
                        value={keyWord}
                        onKeyPress={this.handleKeyPress} 
                        ref={this.textInput}
                    />
                    {
                        keyWord && <img 
                                src={imgs.clearIcon} 
                                className='clear_icon' 
                                onClick={this.clearKeyword}
                            />
                    }
                    <div className='search_btn' onClick={this.handleSearch}>搜索</div>
                </div>
            </SearchWrap>
        )
    }
}
export default Search;